module.exports = __webpack_public_path__ + "img/public/SiteIcons/viewWrite.svg?587a9dbb";